import { createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH } from '../../constant';
import { getToken } from '../../Utils/authUtils';

// PACS (DCM4CHEE) token, issued by the backend so the Keycloak client secret
// never reaches the browser. Resolves to `{ access_token }` like Keycloak did.
export const kcDcmTokenApi = createAsyncThunk('kcDcmToken', async (_: void, { rejectWithValue }) => {
  try {
    const res = await fetch(AUTH.PACS_TOKEN_URL, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    const data = await res.json().catch(() => null);
    if (!res.ok || !data?.result?.dcmAccessToken) {
      return rejectWithValue(data?.msg || 'Error in PACS authorization');
    }
    return { access_token: data.result.dcmAccessToken };
  } catch (error) {
    return rejectWithValue(error instanceof Error ? error.message : String(error));
  }
});
